import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Provider as ReduxProvider } from "react-redux";
import Router from "./router/Router";
import theme from "./theme";

export const Root = ({ history, store }) => (
  <ReduxProvider store={store}>
    <ThemeProvider theme={theme}>
      <Router history={history} />
    </ThemeProvider>
  </ReduxProvider>
);
Root.displayName = "Root";

export default Root;
